import React from 'react';
import Translation from '../../translation/translation';

class FinderHeaderComponent extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        $(this.refs.listViewButton).on('click', this.props.onListViewClick);
        $(this.refs.mapViewButton).on('click', this.props.onMapViewClick);
    }

    render() {
        var listMapButtonsStyle = {};
        if (this.props.inDetailMode) {
            listMapButtonsStyle.display = 'none';
        }

        return (
            <div className="fsf__app-header fsf-app-header">
                {this.props.detailModeStation && <Translation
					className="fsf-app-header__show-list-view"
					translationKey="fitting-station-finder-app-show-all-stations"
					onClick={this.props.onShowStationListClick}
				/>}
                {this.props.detailModeStation ?
                    <p className="fsf-app-header__station-default-name">{this.props.detailModeStation.name}</p> :
                    <p className="fsf-app-header__station-default-name">
                        <Translation
                            translationKey="fitting-station-finder-app-stations-header-location"
                            placeholder={{ location: this.props.location }}
                        />
                    </p>
                }
                <div className="fsf-app-header__view-tab-nav view-tab-nav" style={listMapButtonsStyle}>
                    <span className={`view-tab-nav__button js-show-listview ${this.props.isListActive ? ' view-tab-nav__button--list-view view-tab-nav__button--active' : ''}`} ref="listViewButton" >
                        <img className="view-tab-nav__icon view-tab-nav__icon--list" src="https://static.tyroola.com/images/icons/list.svg" alt="List view" />
                        <Translation translationKey="fitting-station-finder-app-listview" />
                    </span>
                    <span className={`view-tab-nav__button js-show-mapview ${!this.props.isListActive ? ' view-tab-nav__button--list-view view-tab-nav__button--active' : ''}`} ref="mapViewButton">
                        <img className="view-tab-nav__icon view-tab-nav__icon--map" src="https://static.tyroola.com/images/icons/map-marker.svg" alt="Map view" />
                        <Translation translationKey="fitting-station-finder-app-mapview" />
                    </span>
                </div>
            </div>
        );
    }
}

export default FinderHeaderComponent;
